import { useEffect, useState } from 'react';

import CustomerApi from '@empiriecom/mybuy-components/api/CustomerApi';
import type { CustomerInformation } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models';
import { useConfig, useSession } from '@packages/shared';

export const useCustomerInformation = () => {
  const {
    apiEndpoints: { customer: apiCustomerUrl },
  } = useConfig();

  const { jwtToken } = useSession();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [customerInformation, setCustomerInformation] = useState<CustomerInformation | undefined>();

  useEffect(() => {
    let isSubscribed = true;
    if (jwtToken && apiCustomerUrl) {
      const customerApi = new CustomerApi(jwtToken, {
        basePath: apiCustomerUrl,
      });

      if (!customerApi) {
        setCustomerInformation(undefined);
        setIsLoading(false);
      } else {
        customerApi
          .getInformation()
          .then((information) => {
            if (isSubscribed) {
              setCustomerInformation(information);
              setIsLoading(false);
            }
          })
          .catch(() => {
            if (isSubscribed) {
              setCustomerInformation(undefined);
              setIsLoading(false);
            }
          });
      }
    }
    // eslint-disable-next-line consistent-return
    return () => {
      // Can't perform a React state update on an unmounted component
      isSubscribed = false;
    };
  }, [apiCustomerUrl, jwtToken]);

  return { isLoading, customerInformation };
};
